<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'
import { useMediaQuery } from '@vueuse/core'

import DefaultLayout from '@/layouts/default.vue'
import MobileLayout from '@/layouts/checkout.vue'

const isMobile = useMediaQuery('(max-width: 768px)')

// Dynamically switch layouts after hydration
const currentLayout = computed(() => {
    return isMobile.value
        ? defineAsyncComponent(() => import('@/layouts/checkout.vue'))
        : defineAsyncComponent(() => import('@/layouts/default.vue'))
})
</script>

<template>
    <component :is="isMobile ? MobileLayout : DefaultLayout">
        <slot />
    </component>
</template>
